<template>

	<nav id="js-facets" class="g-facets" v-if="visibleFacets || bopisFacets">
		<div class="g-facets__overlay" tabindex="-1" data-micromodal-close>
			<div class="g-facets__content" role="dialog" aria-modal="true" aria-labelledby="g-facets-title">
				<button type="button" class="g-button--no-styling u-icon-cross g-facets__close-button" aria-label="Close Filters" data-micromodal-close></button>
				<div class="g-facets__inner">
					<div class="g-facets__form">
						<div id="g-facets-title" :class="{ 'g-facets__heading-section': true, 'g-facets__has-store': goBackToStore && goBackToStore.identifier}">
							<div class="g-facets__heading-container">
								<div class="g-facets__heading-inner">
									<h2 class="g-facets__heading">
										<span class="g-facets__heading-icon u-icon-filter-sliders" aria-hidden="true" focusable="false"></span>
										<span class="g-facets__heading-text">Filter</span>
									</h2>
									<a v-if="filterSummary.length > 0" class="g-facets__clear-all-link g-facets__clear-all-link-primary" @click="clearFacets()">Clear All</a>
									<a v-if="goBackToStore && goBackToStore.identifier && goBackToStore.link" class="g-facets__go-back-to-store" :href="`${goBackToStore.link}`">
										Back to Store Page <span class="u-icon-curved-arrow-left g-facets__go-back-to-store-icon" aria-hidden="true"></span>
									</a>
								</div>
							</div>
							<div class="g-facets__applied-items" v-if="filterSummary.length > 0">
								<ul class="g-facets__list">
									<li class="g-facets__applied-item" v-for="filter in filterSummary" :key="filter.filterValue">
										<button type="button" class="g-facets__applied-label"  @click="toggleFilter( filter.field, typeof filter.value !== 'object' ? filter.value : [ filter.value.rangeLow, filter.value.rangeHigh ] )">
											<span class="g-facets__applied-label-icon u-icon-cross"></span>
											<span class="g-facets__applied-label-text" v-if="filter.field !== 'bopis' && filter.field !== 'current_store_inventory'">{{ filter.filterValue }}</span>
											<span class="g-facets__applied-label-text" v-else-if="filter.field == 'bopis'">{{ filter.filterLabel }}</span>
											<span class="g-facets__applied-label-text" v-else>{{ selectedStore && selectedStore.name ? filter.filterLabel + ': ' + selectedStore.name : filter.filterLabel }}</span>
										</button>
									</li>
								</ul>
							</div>
							<div v-if="pagination && pagination.totalResults > 0" class="g-facets__product-count">
								<span class="g-product-list__product-count">{{ pagination.totalResults }} {{ pagination.totalResults > 1 ? 'Items' : 'Item' }}</span>
								<a v-if="filterSummary.length > 0 && goBackToStore && goBackToStore.identifier" class="g-facets__clear-all-link g-facets__clear-all-link-secondary" @click="clearFacets()">Clear All</a>
							</div>
						</div>
						<div class="g-facets__list-section">
							<ul class="g-facets__list">
								<facet-bopis v-if="bopisFacets.length" :facets="bopisFacets"></facet-bopis>
								<li class="g-facet-set g-facet-set-categories" v-if="categories.length && categoryCode" v-for="section in categories" :class="{'g-facet-set--collapsed': section.collapse}" :key="section.label">
									<category :section="section" :active-category-code="categoryCode"></category>
								</li>
								<li class="g-facet-set" :class="{'g-facet-set--collapsed': facet.collapse}" v-for="facet in visibleFacets" :key="facet.field">
									<h3 class="g-facet-set__heading" @click="facet.collapse = !facet.collapse">
										<button class="g-facet-set__label g-button--no-styling">
											{{ facet.label }}
										</button>
									</h3>
									<facet-list v-if="facet.type === 'list' || facet.type == null && facet.values.length > 0" :facet="facet" />
									<facet-grid v-if="facet.type === 'grid' && facet.values.length > 0" :facet="facet" />
									<facet-palette v-if="facet.type === 'palette' && facet.values.length > 0" :facet="facet" />
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>

	</nav>

</template>

<script>

	import {BopisController} from 'custom-extensions/bopis';
import Search from '../../Search';
import Category from './Category';
import FacetsTypeBopis from './FacetTypeBopis';
import FacetsTypeGrid from './FacetsTypeGrid';
import FacetsTypeList from './FacetsTypeList';
import FacetsTypePalette from './FacetsTypePalette';

	export default {
		data() {
			return {
				uniqueId: '',
				bopisController: {},
				categoryCode: mivaJS.Category_Code,
				categories: mivaJS.returnsCategories ? mivaJS.returnsCategories : {}
			}
		},
		props: {
			showFacets: {
				default() {
					return true;
				}
			},
			facets: {
				default() {
					return [];
				}
			},
			filterSummary: {
				default() {
					return [];
				}
			},
			pagination: {
				default() {
					return [];
				}
			}
		},
		asyncComputed: {
			selectedStore() {
				if (this.storeAvailabilityFacetCurrentValue?.value) {
					if (this.storeAvailabilityFacetCurrentValue?.value === this.controller?.store?.state?.myStore?.identifier && this.controller?.store?.state?.myStore?.name) {
						return this.controller.store.state.myStore;
					}

					return this.getSelectedStore(this.storeAvailabilityFacetCurrentValue?.value);
				}

				if (this.controller?.store?.state?.myStore?.identifier && this.controller?.store?.state?.myStore?.name) {
					return this.controller.store.state.myStore;
				}

				return {};
			},
			async goBackToStore () {
				const storeParameter = new URLSearchParams(window.location.search).get('store');
				if (!storeParameter) {
					return {};
				}

				const store = await this.getSelectedStore(storeParameter);

				if (!store?.identifier) {
					return {};
				}

				const breadcrumbLinks = document.getElementsByClassName('js-breadcrumb-back-to');
				for (const breadcrumbLink of breadcrumbLinks) {
					if (breadcrumbLink.classList.contains('js-breadcrumb-back-to--updated')) {
						continue;
					}

					breadcrumbLink.classList.add('js-breadcrumb-back-to--updated', 'u-hidden');

					const newBreadcrumb = document.createElement('li');
					newBreadcrumb.classList.add('g-breadcrumbs__list__item', 'g-list-inline__item', 'u-hidden--l', 'g-breadcrumbs--back-to');
					newBreadcrumb.innerHTML = `
						<a href="${store.link}" class="u-flex u-inline--l g-layout--align-center">
							<span class="u-hidden--l u-flex g-layout--align-center"><span class="g-breadcrumbs--arrow-icon u-icon-arrow-left u-hidden--l u-flex" aria-hidden="true"></span> Back to&nbsp;</span><span class="g-breadcrumb--mobile-parent--name">Store Page</span>
						</a>
					`;

					breadcrumbLink.after(newBreadcrumb);
				}

				return store;
			}
		},
		computed: {
			bopisFacets () {
				return this.facets.filter(filter => filter.label.indexOf('(hidden)') === -1 && (filter.field === 'bopis' || filter.field === 'current_store_inventory'));
			},
			visibleFacets () {
				return this.facets.filter(filter => filter.label.indexOf('(hidden)') === -1 && (filter.field !== 'bopis' && filter.field !== 'current_store_inventory') && filter.field !== 'code');
			},
			storeAvailabilityFacet() {
				const facets = this.facets.filter(filter => filter.field === 'current_store_inventory');
				return facets.length ? facets[0] : null;
			},
			storeAvailabilityFacetCurrentValue () {
				const facetValue = this.storeAvailabilityFacet?.values?.filter(filter => filter.active);
				return facetValue.length ? facetValue[0] : null;
			},
		},
		methods: {
			toggleFilter ( field, value ) {

				Search.client.filter( field, value ).search();

			},
			clearFacets() {

				Search.client.clearFacets().search();

			},
			async getSelectedStore (identifier) {
				const store = await this.bopisController?.api?.singleLocationLookup(identifier);
				return store;
			}
		},
		created() {
			this.uniqueId = this._uid;
			this.bopisController = BopisController;
		},
		components: {
			'category': Category,
			'facet-bopis': FacetsTypeBopis,
			'facet-list': FacetsTypeList,
			'facet-grid': FacetsTypeGrid,
			'facet-palette': FacetsTypePalette
		}
	}

</script>
